module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAAPklEQVQ4T2P8////fwYaAsahbwENQwdsNOOoBYRCAJSK6gkpokR+GCRTmgcRJeFLjN7RfEAwlIZHMqVphQMAwqom66l/+7gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/1_0_icon_fenlei.png
// module id = DUNP
// module chunks = 42